export const BACKEND_HOST = process.env.REACT_APP_BACKEND_HOST || 'https://ansar-backend.onrender.com/';
